<template>
  <div class="fold">
    
    <div :class="['text',{'textM': text =='......'}]">
      <span
        :style="{ 'max-height': textOpenFlag ? textHeight : '' }"
        :class="{unfoldText: textOpenFlag} "
        ref="desc"
        v-html="text"
      >
      </span>
      <span
        v-if="showBtnFlag"
        @click="textOpenFlag = !textOpenFlag"
        class="btn"
        >{{ textOpenFlag ? "展开" : "收起" }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "QaMobileTerminalTextContent",

  props: {
    // 文本
    text: {
      type: String,
      default: ''
    },
    // 超过几行显示展开
    showLine: {
      type: Number,
      default: 18
    }
  },

  data() {
    return {
      textHeight: null,
      textOpenFlag: false,
      showBtnFlag: false,
    };
  },

  watch: {
    text: {
      handler(val) {
        
        this.$nextTick(() => {
          this.calculateText()
        });
      },
      immediate: true
    }
  },

  mounted() {
  },

  methods: {
    calculateText() {
      let twoHeight = 22 * this.showLine;
      this.textHeight = `${twoHeight}px`;
      let curHeight = this.$refs.desc.offsetHeight;
      if (curHeight > twoHeight) {
        this.textOpenFlag = true;
        this.showBtnFlag = true;
      } else {
        this.textOpenFlag = false;
        this.showBtnFlag = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$mainColor: #5864ff;
.fold {
  // 1.文字收缩
  .text {
    position: relative;
    line-height: 22px;
    .unfoldText {
      overflow: hidden;
      display: block;
    }
    // .unfoldText
  }
  .btn {
    line-height: 19px;
    font-size: 14px;
    color: $mainColor;
    position: absolute;
    right: 0px;
    bottom: 2px;
    background-color: #fff;
    padding-left: 20px;
    padding-right: 10px;
    &:before {
      // z-index: 3;
      content: "...";
      position: absolute;
      bottom: 2px;
      right: 40px;
      width: 16px;
      padding-left: 30px;
      background: linear-gradient(to right, rgba(255, 255, 255, 0.1), #fff 45%);
    }
    &:hover {
      color: orange;
    }
  }
}
@keyframes siz {
    from{width: 0;}
    to{width: 100%;}

}
.textM{
    overflow: hidden;
    white-space: nowrap;
    letter-spacing: 0.15em;
    font-size: 22px;
    animation: siz 1.5s steps(60, end) infinite;

}

</style>
